import React from 'react';
import PropTypes from 'prop-types';
import { css, cx } from '@bd/bdui-styles/emotion';
import Header from './Header3';
import Footer from './Footer';
import { FavoritesStatus } from './Favorites';
import CompareBar from './CompareBar';
import FooterPromoBanner from './FooterPromoBanner';

const styles = css`
  position: relative;
`;

function PageWrapper({ children, className }) {
  return (
    <div className={cx(styles, className)}>
      <Header />
      <div id="mainContent">
        { children }
      </div>
      <FavoritesStatus />
      <CompareBar />
      <Footer />
      <FooterPromoBanner />
    </div>
  );
}

PageWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

PageWrapper.defaultProps = {
  className: undefined,
};

export default PageWrapper;



// WEBPACK FOOTER //
// ./src/components/PageWrapper.js